import { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import InfiniteScroll from '../../InfiniteScroll/InfiniteScroll'
import Icon from '../../Icons'
import API from '../../../api/api'

import MaintenanceRequestActivity from './components/MaintenanceRequestActivity'
import MaintenanceRequestDetails from './components/MaintenanceRequestDetails'

const MaintenanceRequestPreview = ({ data, handleClose, buildingData }) => {
  const { t } = useTranslation(['maintenance', 'common'])
  const [activities, setActivities] = useState([])
  const [errorMessage, setErrorMessage] = useState(null)
  const timeout = useRef(null)

  const getRecentActivityData = () => {
    API.getMaintenanceRequestActivities(data.id)
      .then(({ data }) => {
        setActivities(data)
      })
      .catch(() => {
        setErrorMessage(t('maintenance:requestPreview.errors.couldNotLoadActivities'))
        timeout.current = setTimeout(() => {
          setErrorMessage(null)
        }, 2000)
      })
  }

  useEffect(() => {
    getRecentActivityData()
    return () => {
      if (timeout.current) clearTimeout(timeout.current)
    }
  }, [])

  return (
    <div className="ctp-maintenance-request-preview">
      {errorMessage ? <div className="error-message">{errorMessage}</div> : null}
      <div className="request-main-container">
        <div className="left-side">
          <div className="navigation-container">
            <button className="button back-button button-transparent" onClick={handleClose}>
              <Icon icon="arrow" />
              <span>{t('common:actions.back')}</span>
            </button>
          </div>
          <MaintenanceRequestDetails
            getRecentActivityData={getRecentActivityData}
            data={data}
            buildingData={buildingData}
          />
        </div>

        <div className="right-side">
          <div className="recent-activities-header">
            <div className="title">{t('maintenance:requestPreview.recentActivities')}</div>
          </div>
          {activities.length ? (
            <div className="recent-activities-list">
              <InfiniteScroll
                data={activities}
                renderItem={(item) => (
                  <MaintenanceRequestActivity activity={item} timezone={buildingData?.timezone} />
                )}
                style={{ height: `calc(100vh - 362px)` }}
              />
            </div>
          ) : (
            <div className="recent-activities-content">
              {t('maintenance:requestPreview.noResults')}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

MaintenanceRequestPreview.propTypes = {
  data: PropTypes.object,
  buildingData: PropTypes.object,
  handleClose: PropTypes.func,
}

export default MaintenanceRequestPreview
